import { Empty, Spin, Cascader } from "antd";
import { find, isEmpty } from "lodash";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import React, { useState, useRef } from "react";
import memberDetailsService from "@services/memberDetails.service";
import { ActionMultiLevel } from "@pages/member-details/care-coordination/constants";
import "./multiLevelSelect.scss";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../constants/constants";

const MultiLevelSelect = (props: {
  patientId: any;
  setIsUpdating: (arg0: boolean) => void;
  referenceName: any;
  value: any;
  handleSelect: (arg0: any) => void;
  disabled: boolean;
  isMultiSelect?: boolean;
  interventionId?: any;
  subTaskId?: any;
}) => {
  const [dropDownOptions, setDropDownOptions] = useState<any>([]);
  const [loadingOptions , setLoadingOptions] = useState<boolean>(false);

  const getOptions = () => {
    if (isEmpty(dropDownOptions)) {
      props.setIsUpdating(true);
      setLoadingOptions(true);
      memberDetailsService.fetchAttributeDropdown(props.referenceName, props.patientId, props.interventionId, props.subTaskId, ActionMultiLevel).subscribe({
        next: (response: any) => {
          setDropDownOptions(response?.data?.data?.data);
          props.setIsUpdating(false);
          setLoadingOptions(false);
        },
        error: (error) => {
          console.log(error);
          props.setIsUpdating(false);
          setLoadingOptions(false);
        },
      });
    }
  };

  const filter = (inputValue: string, path: any[]) => path.some((option) => (option.label as string).toLowerCase().indexOf(inputValue.toLowerCase()) > -1);

  const handleChange = ({ value, options }: any) => {
    props.handleSelect({ value: value.join("$|"), dropDownOptions: find(dropDownOptions, { value: value }) });
  };

  return (
    <div
      onClick={() => {
        if(!props.disabled){
          getOptions();
        }
      }}
    >
      <Cascader
        className="ui-select multilevelSelect"
        placeholder="Please select"
        showSearch={{ filter }}
        allowClear={false}
        notFoundContent={loadingOptions ? <Spin size="small" indicator={<HealthemSpinner />} /> : <DataNotFound message={NO_DATA_FOUND} />}
        onChange={(value, options) => handleChange({ value, options })}
        displayRender={(labels: string[], selectedOptions) => {
          return `${labels[labels.length - 1]}`;
        }}
        value={(props.value ?? "").split("$|").join(", ")}
        options={dropDownOptions}
        disabled={props.disabled}
      />
    </div>
  );
};

export default MultiLevelSelect;
